var React = require('react');

function Alert (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 31C7.716 31 1 24.284 1 16C1 7.716 7.716 1 16 1C24.284 1 31 7.716 31 16C31 24.284 24.284 31 16 31ZM16 28C22.627 28 28 22.627 28 16C28 9.373 22.627 4 16 4C9.373 4 4 9.373 4 16C4 22.627 9.373 28 16 28ZM17 22.534V22.949C17 24.283 15 24.283 15 22.949V22.534C15 21.201 17 21.201 17 22.534ZM17 8.53V18C17 19.333 15 19.333 15 18V8.53C15 7.197 17 7.197 17 8.53Z"}));
}

Alert.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Alert;

Alert.default = Alert;
